module.exports = __webpack_public_path__ + "static/media/logo_white.5c66161c.svg";